var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCompanyIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.921 8.743h-.294a.104.104 0 0 1-.104-.104V5.384c0-.11-.09-.2-.2-.2H8.126c-.11 0-.2.09-.2.2v3.255a.103.103 0 0 1-.103.104h-.589a.104.104 0 0 1-.104-.104V5.384c0-.11-.089-.2-.199-.2H5.736c-.11 0-.2.09-.2.2v3.255a.104.104 0 0 1-.103.104h-.38a.104.104 0 0 1-.105-.104V3a.408.408 0 0 0-.407-.407H1.354A.408.408 0 0 0 .946 3v5.64a.104.104 0 0 1-.104.104H.754a.416.416 0 1 0 0 .831h9.167a.416.416 0 1 0 0-.83zM3.943 4.304H1.952a.312.312 0 1 1 0-.624h1.991a.312.312 0 1 1 0 .624zm.313 1.477c0 .172-.14.312-.313.312H1.952a.312.312 0 1 1 0-.624h1.991c.172.001.311.14.311.312h.002zM1.952 7.257h1.991a.312.312 0 1 1 0 .624H1.952a.312.312 0 1 1 0-.624zM3.943 1.608c0-.11-.148-.199-.333-.199h-.142a.104.104 0 0 1-.104-.104v-.89a.416.416 0 0 0-.833 0v.89a.103.103 0 0 1-.104.104h-.143c-.183 0-.333.09-.333.199V2.1c0 .058.046.104.104.104h1.783a.104.104 0 0 0 .104-.104l.001-.492z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyIcon);
export default __webpack_public_path__ + "static/media/company-icon.6a84746f.svg";
export { ForwardRef as ReactComponent };